import React from "react";

const StarIcon = ({ fill }: { fill: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8064 4.62122C15.5401 3.13472 17.6598 3.13473 18.3934 4.62122L21.4039 10.7212L28.1356 11.6994C29.7761 11.9377 30.4311 13.9537 29.244 15.1108L24.3729 19.8589L25.5228 26.5634C25.8031 28.1973 24.0882 29.4432 22.6209 28.6718L16.5999 25.5063L10.5789 28.6718C9.11162 29.4432 7.39675 28.1973 7.67697 26.5634L8.82689 19.8589L3.95577 15.1108C2.76874 13.9537 3.42376 11.9377 5.0642 11.6994L11.7959 10.7212L14.8064 4.62122Z"
        fill={fill}
        stroke={fill}
        strokeWidth={`2`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StarIcon;
